import React from "react";
import ControlLabel from "react-bootstrap/lib/ControlLabel";
import FormControl from "react-bootstrap/lib/FormControl";
import FormGroup from "react-bootstrap/lib/FormGroup";
import HelpBlock from "react-bootstrap/lib/HelpBlock";

import "./InvitationSignUpForm.scss";

interface Props {
  email: string;
  emailError?: string;
  onEmailChanged: (event: React.ChangeEvent<FormControl.FormControlProps>) => void;
  onPasswordChanged: (event: React.ChangeEvent<FormControl.FormControlProps>) => void;
  onPasswordConfirmationChanged: (event: React.ChangeEvent<FormControl.FormControlProps>) => void;
  password: string;
  passwordConfirmation: string;
  isValidEmail: boolean;
}

const InvitationSignUpForm: React.FC<Props> = props => {
  const {
    email,
    emailError,
    onEmailChanged,
    onPasswordChanged,
    onPasswordConfirmationChanged,
    password,
    passwordConfirmation,
    isValidEmail,
  } = props;

  const buildEmailValidationState = isValidEmail ? null : "error";

  return (
    <>
      <FormGroup
        className="top-12 email-group"
        controlId="email"
        validationState={buildEmailValidationState}
      >
        <ControlLabel>Email</ControlLabel>
        <FormControl name="user[email]" type="email" value={email} onChange={onEmailChanged} />
        {!isValidEmail && <HelpBlock>{emailError}</HelpBlock>}
      </FormGroup>

      <FormGroup className="top-12 password-group" controlId="password">
        <ControlLabel>Password</ControlLabel>
        <FormControl
          name="user[password]"
          value={password}
          onChange={onPasswordChanged}
          type="password"
        />
      </FormGroup>

      <FormGroup className="top-12 password-confirmation-group" controlId="passwordConfirmation">
        <ControlLabel>Password Confirmation</ControlLabel>
        <FormControl
          name="user[password_confirmation]"
          value={passwordConfirmation}
          onChange={onPasswordConfirmationChanged}
          type="password"
        />
      </FormGroup>
    </>
  );
};

export { InvitationSignUpForm };
